import { OrderTracking, OrderTrackingDelivery } from './order.models';

import { ApiCardAdjustments, ApiOrderTracking } from '@api/_api/api-order/api-order.models';
// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
import { toLocaleString } from '@core/application/use-cases/dates/to-locale-string.use-case';
import { DiscountDetails } from '@features/payment';

/**
 * Clase de utilidad para transformar los objetos que devuelve el api de inditex en los objetos que usaremos en el cms, widgets y render
 *  */

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class OrderModelsTransformer {
    public static ApiCardAdjustmentsToDiscountDetails(apiCardAdjustments: ApiCardAdjustments): DiscountDetails {
        const discountDetails: DiscountDetails = {
            saveCard: false,
            valid: true,
            values: {
                amount: apiCardAdjustments.adjustments[0].cardAmount,
                balance: apiCardAdjustments.adjustments[0].cardBalance,
                cvv2: apiCardAdjustments.adjustments[0].cardCvv,
                number: apiCardAdjustments.adjustments[0].cardNumber,
                variant: apiCardAdjustments.adjustments[0].cardVariant,
                giftCardType: apiCardAdjustments.adjustments[0].giftCardType,
                paymentMethodKind: 'gift_card',
                paymentMethodType: '',
            },
        };
        return discountDetails;
    }

    public static ApiOrderTracking(apiOrderTracking: ApiOrderTracking): OrderTracking {
        const orderTracking: OrderTracking = apiOrderTracking as OrderTracking;
        for (const delivery of orderTracking.orderDelivery) {
            delivery.icon = OrderModelsTransformer.getIcon(delivery);
            delivery.fechaEstimada = delivery.fechaEstimada ? toLocaleString(delivery.fechaEstimada) : '';
        }
        return orderTracking;
    }

    private static getIcon(delivery: OrderTrackingDelivery): string {
        const mapping = {
            P: 'delivery', // Estado inicial
            Z: 'delivery', // Estado inicial
            M: 'pending-delivery', // En trámite
            F: 'pending-delivery', // En trámite
            A: 'pending-delivery', // En trámite
            N: 'cancel-delivery', // Cancelado
            G: 'pending-delivery', // En trámite
            L: 'pending-delivery', // En trámite
            E: 'pending-delivery', // En trámite
            R: 'pending-delivery', // En tránsito
            S: 'pending-delivery', // En tránsito
            D: 'pending-delivery', // En tránsito
            U: 'pending-delivery', // En tienda/En transporte
            K: 'confirmed-delivery', // Entregado
            O: 'pending-delivery', // Entrega parcial
            X: 'cancel-delivery', // Cancelado
        };
        return mapping[delivery.statusSuborder] || null;
    }
}
